var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-header'),_c('cut-features'),_c('anti-consumer'),_c('bad-cinematics'),_c('map-ownership')],1)}
var staticRenderFns = []

export { render, staticRenderFns }